function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 10c0-3.861 3.139-7 7-7s7 3.139 7 7c0 5.25-7 12.234-7 12 0 .234-7-6.75-7-12zm4.666 0a2.333 2.333 0 104.668 0c0-1.282-1.05-2.332-2.334-2.332S9.666 8.718 9.666 10z",
  fillRule: "evenodd",
  fill: "currentColor"
});

var SvgLocationCoordinate = function SvgLocationCoordinate(props) {
  return React.createElement("svg", _extends({
    height: 24,
    width: 24
  }, props), _ref);
};

export default SvgLocationCoordinate;